export let keytipAriaDescription = "j1GxKe";
export default {keytipAriaDescription};